import { SearchX } from 'lucide-react';
import { Flex } from '@/components/Flex';
import { Icon } from '@/components/Icon';
import { Link } from '@/components/Link';
import { Page } from '@/components/Page';
import type { FileRouteTypes } from '@/routeTree.gen';
import * as styles from './index.css';

const DEFAULT_MESSAGE = 'お探しのページが見つかりませんでした。';

type NotFoundProps = {
    kind: 'system' | 'client';
    title?: string;
    message?: string;
    /** Defaults to `kind`'s landing page — override for a more useful destination than "start over". */
    backTo?: { to: FileRouteTypes['to']; label: string };
};

export const landingPagePath = { system: '/system', client: '/' } as const;

/** Throw from a loader when the thing it looked up doesn't exist, so the route's
 * `errorComponent` can render {@link NotFound} instead of a retry prompt — retrying
 * a lookup that will never succeed isn't a meaningful recovery action. */
export class NotFoundError extends Error {}

/**
 * Rendered inside an authenticated subtree's shell (Sidebar/Topbar stay visible)
 * when a route within it doesn't match anything.
 */
export function NotFound({
    kind,
    title,
    message = DEFAULT_MESSAGE,
    backTo = { to: landingPagePath[kind], label: 'トップページに戻る' },
}: NotFoundProps) {
    return (
        <Page.Root>
            {title && <Page.Header title={title} />}
            <Page.Content>
                <Flex direction="column" align="center" justify="center" gap="4" className={styles.container}>
                    <Icon icon={SearchX} size="lg" />
                    <p>{message}</p>
                    <Link to={backTo.to}>{backTo.label}</Link>
                </Flex>
            </Page.Content>
        </Page.Root>
    );
}
